export default "__VITE_ASSET__8Cs4sVkr__"